module.exports = __webpack_public_path__ + "static/media/kanji_model.78b434e5.tflite";